import { styled } from '@mui/material/styles';
import { Drawer } from '@sunwisesoftware/sunwise-ui';

import { PADDING } from '../constants';
import { getDrawerSizeInPX } from '../helpers';

const StyledDrawer = styled(Drawer)(({ drawersize, theme }) => ({
    '& ::-webkit-scrollbar': { height: 0, width: 0 },
    '& .MuiDrawer-paper': {
        background:
            theme.palette.mode === 'dark'
                ? theme.palette.background.paper
                : '#002438',
        borderRight: 0,
        padding: `${PADDING}px`,
        transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1)',
        width: getDrawerSizeInPX(drawersize),
    },
}));

export default StyledDrawer;
